import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Reveal from 'react-reveal/Reveal';

import {
  LinkWrap,
  Overlay
} from "../styles/Work.styles";

import Footer from '../components/Footer';

import { Efect, Efect1, Efect2  } from "../styles/effect.styles";
  

const News = ({ history }) => {
const [toCase, setCase] = useState("");
const [coord, setCoords] = useState();

useEffect(() => {
    toCase &&
      setTimeout(() => {
        history.push(toCase);
      }, 600);
  }, [toCase, history]);


  const handleCaseSwap = (e, uri) =>
    e.x < coord + 15 && e.x > coord - 15 && setCase(uri);

  return (
    <div>
      <Efect/>
      <Efect1/>
      <Efect2/>

      <div className="jumbotron head"/>

      <Reveal effect="fadeIn">
              <section className='jumbotron imgtop'>
                <img
                  src="./img/Blog.jpg"
                  className="img-fluid"
                  alt="#"
                />
              </section>
             </Reveal>

      <Reveal effect="fadeInUp">
       <section className='container-fluid pb-0'>
          <div className='row m-2-hor'>
            <div className='col-md-12'>
              <h1 className="heading mt-5">Words of Wellness - with Dr. Michelle</h1>
            </div>
          </div>
       </section>
      </Reveal>

      <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW14"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW14")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW14.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> April 14, 2025</div>
                          <div className='name'>Time to Eat!</div>
                          <div className='content'>
                          Does the Order in which you Eat your Food Matter?
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW13"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW13")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW13.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> April 07, 2025</div>
                          <div className='name'>IV Therapy</div>
                          <div className='content'>
                          Should I book and IV Therapy appointment?
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW12"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW12")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW12.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> October 21, 2024</div>
                          <div className='name'>Vitamin D</div>
                          <div className='content'>
                          Called a Vitamin, but acts like a Hormone
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW11"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW11")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW11.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> October 7, 2024</div>
                          <div className='name'>Cholesterol</div>
                          <div className='content'>
                          The Good, The Bad, & the Balanced!
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW9"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW10")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW10.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> September 30, 2024</div>
                          <div className='name'>Sleep</div>
                          <div className='content'>
                          Is your Sleep Optimal?
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW9"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW9")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW9.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> September 18, 2024</div>
                          <div className='name'>Cold & Flu Season</div>
                          <div className='content'>
                          Let's Protect your body against Sickness!
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW8"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW8")}>
                        <div className='bg'>
                          <img
                            src="./img/news/WOW8.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> September 2, 2024</div>
                          <div className='name'>Seasons Change</div>
                          <div className='content'>
                          Seasons Change ... And so should your diet!
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW7"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW7")}>
                        <div className='bg'>
                          <img
                            src="./img/news/water.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> June 10, 2024</div>
                          <div className='name'>Electrolytes: Stay Current</div>
                          <div className='content'>
                          Why Electrolytes will keep you charged Up this summer
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW6"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW6")}>
                        <div className='bg'>
                          <img
                            src="./img/news/All.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> April 22, 2024</div>
                          <div className='name'>It's Just my Allergies!</div>
                          <div className='content'>
                          Reaching for the Kleenex and eye drops rather than the sunglasses with warmer weather?
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW5"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW5")}>
                        <div className='bg'>
                          <img
                            src="./img/news/Migraine.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> April 15, 2024</div>
                          <div className='name'>Migraine</div>
                          <div className='content'>
                            More than just a bad headache
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW4"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW4")}>
                        <div className='bg'>
                          <img
                            src="./img/news/Mag.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> April 8, 2024</div>
                          <div className='name'>0mg = Magnesium Deficiency</div>
                          <div className='content'>
                            Magnesium is one of the most common nutrient deficiencies
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

       <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW3"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW3")}>
                        <div className='bg'>
                          <img
                            src="./img/news/Eggs.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> April 1, 2024</div>
                          <div className='name'>Egg-cellent Health</div>
                          <div className='content'>
                            What health benefits do eggs provide? 
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>


      <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW2"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW2")}>
                        <div className='bg'>
                          <img
                            src="./img/news/Alzheimers.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> March 25, 2024</div>
                          <div className='name'>Forget me? Not!</div>
                          <div className='content'>
                            Alzheimer's Disease may be Diabetes Type III 
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

      <Reveal effect="fadeInUp">
      <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/WOW1"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/WOW1")}>
                        <div className='bg'>
                          <img
                            src="./img/news/Protein.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> March 15, 2024</div>
                          <div className='name'>Protein: The Magic Macro</div>
                          <div className='content'>
                            Is protein magic? No, but it does provide many health benefits 
                          </div>
                        </div>
                        <div className='icon'>
                          <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </section>
      </Reveal>

      <Reveal effect="fadeInUp">
       <section className='container-fluid'>
          <div className='row m-2-hor'>

            <div className='col-md-4 slick slicknews p-3 mb-0'>
              <div className='slick-slide d-block'>
                <div className='mr-0'>
                  <div className='itm mr-0'>
                    <LinkWrap active={toCase === "/NPLEXblog"}>
                    <Overlay active={!!toCase} onMouseDown={e => setCoords(e.nativeEvent.x)}
                      onMouseUp={e => handleCaseSwap(e.nativeEvent, "/NPLEXblog")}>
                        <div className='bg'>
                          <img
                            src="./img/news/NPLEX.png"
                            className="img-fluid"
                            alt="Imageteam"
                          />
                        </div>
                        <div className='desc'>
                          <div className='date'> July 02, 2023</div>
                          <div className='name'>Passing NPLEX I & II</div>
                          <div className='content'>
                            How I was able to successfully pass NPLEX I & II 
                          </div>
                        </div>
                        <div className='icon'>
                           <span>
                            Read More
                          </span>
                        </div>
                    </Overlay>
                  </LinkWrap>
                  </div>
                </div>
              </div>
            </div>

          </div>
       </section>
       </Reveal>


      <Footer />

    </div>
    
  );
};

export default withRouter(News);
